import React from 'react'

import { AttachmentComponent } from 'common/builder/components/chart/FlowChart/components/Block/components/AttachmentComponent/AttachmentComponent'
import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import { FlowChartAttachmentBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartAttachmentBlock'

import { AttachmentButtons } from './AttachmentButtons'

export const AttachmentGenericBlock: BlockComponent<FlowChartAttachmentBlock> = (props) => {
  const { buttons, attachment } = props.block.data

  const hasButtons = buttons.length > 0

  return (
    <InteractiveBlockContainer id={props.block.id}>
      <AttachmentComponent
        attachment={attachment}
        containerProps={{ connectedToNext: hasButtons }}
      />
      <AttachmentButtons buttons={buttons} attachmentAppearance={attachment.appearance} />
    </InteractiveBlockContainer>
  )
}
